import ArrowForwardRounded from '@mui/icons-material/ArrowForwardRounded';
import TrendingDownRounded from '@mui/icons-material/TrendingDownRounded';
import TrendingUpRounded from '@mui/icons-material/TrendingUpRounded';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { formatChange, formatDate, formatValue } from '@/shared/lib/format';
import type { Answer } from '../api/schemas';

type Props = { change: NonNullable<Answer['viewChanged']> };

/** OCBC revised this forecast: the old figure, the new one, and when each was published. */
export function ChangeStrip({ change }: Props) {
  const up = change.to > change.from;
  const Trend = up ? TrendingUpRounded : TrendingDownRounded;
  return (
    <Stack
      component="section"
      aria-label="Forecast revised"
      direction="row"
      sx={{
        alignItems: 'center',
        gap: 1.25,
        px: 1.75,
        py: 1.25,
        border: 1,
        borderColor: 'divider',
        borderRadius: 1.5,
        flexWrap: 'wrap',
      }}
    >
      <Trend aria-hidden sx={{ fontSize: 20, color: 'info.main' }} />
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        {change.instrument} {change.periodLabel} forecast revised
      </Typography>
      <Stack direction="row" sx={{ alignItems: 'center', gap: 0.75, fontVariantNumeric: 'tabular-nums' }}>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {formatValue(change.from)}{' '}
          <Typography component="span" variant="caption">
            ({formatDate(change.fromDate)})
          </Typography>
        </Typography>
        <ArrowForwardRounded aria-label="to" sx={{ fontSize: 16, color: 'text.secondary' }} />
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          {formatValue(change.to)}{' '}
          <Typography component="span" variant="caption" sx={{ fontWeight: 400 }}>
            ({formatDate(change.toDate)})
          </Typography>
        </Typography>
        <Typography variant="caption" sx={{ color: 'text.secondary' }}>
          {formatChange(change.from, change.to)}
        </Typography>
      </Stack>
    </Stack>
  );
}
